import React from "react";
import ContentComponent from "./Content.js";
export default function LandingLayout() {
  return (
      <ContentComponent/>
  );
}
